import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { StyledLoyaltyCompany } from './styles';
import BackArrow from '../../assets/icons/DocumentBulkEditIcons/BackArrow';
import {
  getLoyaltyCompanyByCode,
  getLoyaltyCompanyCoverImage,
  getLoyaltyCompanyFooterImage,
  getLoyaltyCompanyLongDescriptions,
  getLoyaltyCompanyMainDescriptions,
  getLoyaltyCompanyName,
  getLoyaltyCompanyOptionData,
  getLoyaltyCompanyBenefit,
  getLoyaltyCompanyOffers,
} from '../../utils/LoyaltyCompanies';
import useIsDesktop from '../../hooks/v2/useDesktop';
import CompanyInfo from './ComapnyInfo';
import useDashboardLinkPrefix from '../../hooks/useDashboardLinkPrefix';
import { sGetUser } from '../../store/reducers/auth';

const LoyaltyCompany = ({ isBackButtonVisible = true, authUser }) => {
  const { companyCode } = useParams();
  const isDesktop = useIsDesktop();
  const [loyaltyCompanyData, setLoyaltyCompanyData] = useState(null);
  const [companyOptions, setLoyaltyCompanyOptions] = useState(null);
  const [companyBenefits, setLoyaltyCompanyBenefit] = useState(null);
  const [companyOffers, setLoyaltyCompanyOffers] = useState(null);
  const dashboardLinkPrefix = useDashboardLinkPrefix();

  useEffect(() => {
    setLoyaltyCompanyData(getLoyaltyCompanyByCode(companyCode));
  }, [companyCode]);

  useEffect(() => {
    setLoyaltyCompanyOptions(getLoyaltyCompanyOptionData(loyaltyCompanyData));
    setLoyaltyCompanyBenefit(getLoyaltyCompanyBenefit(loyaltyCompanyData));
    setLoyaltyCompanyOffers(getLoyaltyCompanyOffers(loyaltyCompanyData));
  }, [loyaltyCompanyData]);

  return (
    <StyledLoyaltyCompany $backgroundColor="#FAF7F1">
      {loyaltyCompanyData && (
        <>
          {isBackButtonVisible && (
            <div className="back_section">
              <Link to={`${dashboardLinkPrefix}/boligmappa-plus/loyalty`}>
                <BackArrow className="back_arrow_icon" /> Tilbake
              </Link>
            </div>
          )}
          <div className="section">
            <h2>{getLoyaltyCompanyName(loyaltyCompanyData)}</h2>
            <div className="main_description">
              {getLoyaltyCompanyMainDescriptions(loyaltyCompanyData).map(
                (des) => (
                  <p className="main_description">{des}</p>
                )
              )}
            </div>
          </div>
          <div className="section">
            <div className="img_container">
              <img
                alt="Cover"
                src={getLoyaltyCompanyCoverImage(loyaltyCompanyData)}
                className="landscape-horizonal"
              />
            </div>
          </div>
          <div className="section">
            <div className="infor_section">
              <div className="sub_heading_section">
                {companyOptions?.map((cOption) => (
                  <>
                    <h3>{cOption?.heading}</h3>
                    {cOption?.list && (
                      <ul>
                        {cOption?.list?.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    )}
                    {cOption?.descriptions?.map((des) => (
                      <p>{des}</p>
                    ))}
                    {cOption?.image && (
                      <div className="option_img_container">
                        <img
                          alt="Options"
                          src={cOption?.image}
                          className="landscape-horizonal"
                        />
                      </div>
                    )}
                  </>
                ))}
                {isDesktop && (
                  <div className="description_img_container">
                    <img
                      alt=""
                      src={getLoyaltyCompanyFooterImage(loyaltyCompanyData)}
                      className="landscape-horizonal"
                    />
                  </div>
                )}
              </div>
              <div className="long_description_section">
                {getLoyaltyCompanyLongDescriptions(loyaltyCompanyData).map(
                  (des) => (
                    <p>{des}</p>
                  )
                )}
                {!isDesktop && (
                  <div className="description_img_container">
                    <img
                      alt=""
                      src={getLoyaltyCompanyFooterImage(loyaltyCompanyData)}
                      className="landscape-horizonal"
                    />
                  </div>
                )}
              </div>
              <div className="offer_section">
                <div className="offer_wrapper">
                  <h3>{companyOffers?.title}</h3>
                  <p>{companyOffers?.description}</p>
                </div>
                <div className="offer_wrapper">
                  <h3>{companyBenefits?.title}</h3>
                  <p>{companyBenefits?.description}</p>
                  <ul>
                    {companyBenefits?.list.map((item) => (
                      <li>{item}</li>
                    ))}
                  </ul>
                  {authUser?.isSubscribeToBoligmappaPlus && (
                    <div className="benefit_btn">
                      <span>Bruk rabattkode</span>
                      <span className="benefit_btn_text">
                        {companyBenefits?.discountBtnText}
                      </span>
                    </div>
                  )}
                </div>
                {isDesktop && (
                  <CompanyInfo loyaltyCompany={loyaltyCompanyData} />
                )}
              </div>
              {!isDesktop && (
                <div className="company_info">
                  <CompanyInfo loyaltyCompany={loyaltyCompanyData} />
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </StyledLoyaltyCompany>
  );
};

const mapStateToProps = (state) => ({
  authUser: sGetUser(state),
});

export default connect(mapStateToProps)(LoyaltyCompany);
